export enum SettingsType {
  CONTRACTORS = 'contractors',
  RATES = 'rates',
  PARTNERSHIP = 'partnership',
}
